<button
    [matMenuTriggerFor]="notificationMenu"
    class="btn p-0 border-none rounded-circle position-relative notification-btn me-2"
    [ngClass]="notifications.length > 0 ? 'blink' : ''"
    (click)="updateData()"
>
    <i
        class="flaticon-bell-2 fs-20"
        [matBadge]="count"
        matBadgeColor="warn"
        matBadgePosition="before"
    ></i>
</button>
<mat-menu
    class="menu-dropdown notification-menu"
    #notificationMenu="matMenu"
    xPosition="before"
>
    <div
        class="menu-header d-flex align-items-center justify-content-space-between"
    >
        <h5 class="m-0">Notifications</h5>
        <button type="button" class="bg-transparent p-0 border-none">
            Mark all as read
        </button>
    </div>

    <ul class="menu-body">
        <ng-template #noNotification>
            <div
                class="w-100 py-12 d-flex align-items-center justify-content-center"
            >
                <p>No notification to show...</p>
            </div>
        </ng-template>
        <ng-container *ngIf="notifications.length > 0; else noNotification">
            <li
                class="position-relative cursor-pointer"
                *ngFor="let notification of notifications; index as i"
            >
                <div
                    class="d-flex"                    
                    (click)="
                        removeNotification(i);
                        markAsRead(
                            notification.id,
                            true,
                            true,
                            notification?.type,
                            notification?.referenceId
                        )
                    "
                >
                    <i class="flaticon-file-1 icon"></i>
                    <div class="title">
                        <h6 [innerHTML]="notification?.title"></h6>
                        <span
                            ><i class="flaticon-timer"></i>
                            {{ notification.time }}</span
                        >
                    </div>
                </div>
                <button
                    class="close-btn bg-transparent border-none p-0"
                    (click)="
                        removeNotification(i);
                        markAsRead(notification.id, true, false)
                    "
                >
                    <i class="flaticon-close"></i>
                </button>
            </li>
        </ng-container>
    </ul>
    <div class="menu-footer">
        <a
            routerLink="/admin/notification_master"
            class="fw-medium position-relative"
            >View All <i class="flaticon-chevron"></i
        ></a>
    </div>
</mat-menu>
